import {useMemo} from 'react';

const usePermissions = roles =>
  useMemo(() => [roles || ['Admin', 'Staff', 'Owner', 'Operator', 'Portal', 'Viewer', 'Researcher'], false], [roles]);

export default usePermissions;
